'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:dateInput
 * @description
 * # dateInput
 * Directive that handles date input fields. Applies to elements with class "date-input".
 * Uses moment.js to parse dates in various formats and converts them to YYYY-MM-DD format.
 */
angular.module('360StoreAngularApp')
	.directive('dateInput', function () {
		return {
			restrict: 'C',
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				// Parse user input into a standardized date format
				ngModel.$parsers.push(function (value) {
					if (!value) {
						return null;
					}

					const m = window.moment(value, [
						'YYYY-MM-DD',
						'YYYY-M-D',
						'YY-M-D',
						'MM/DD/YYYY',
						'MM/DD/YY',
						'M/D/YYYY',
						'M/D/YY',
						'M/D',
						'MMM D, YYYY',
						'MMMM D, YYYY',
						'MMM D YYYY',
						'MMMM D YYYY'
					], true); // strict parsing mode

					if (m.isValid()) {
						return m.format('YYYY-MM-DD');
					}

					return value; // return original value if parsing fails
				});

				// Format the model value for display in the input
				ngModel.$formatters.push(function (value) {
					if (!value) {
						return '';
					}

					const m = window.moment(value);
					return m.isValid() ? m.format('YYYY-MM-DD') : value;
				});

				// Update the input field when the user leaves it
				element.on('blur', function () {
					const value = ngModel.$modelValue;
					if (value) {
						const m = window.moment(value);
						if (m.isValid()) {
							scope.$apply(function () {
								ngModel.$setViewValue(m.format('YYYY-MM-DD'));
								ngModel.$render();
							});
						}
					}
				});
			}
		};
	});
